export default class StoryPlayerMemento {
    constructor(storyPlayerState) {
        this.data = storyPlayerState;
    }

    // Serialize the memento to object format
    serialize() {
        return this.data;
    }

    // Deserialize the memento so it can be loaded
    deserialize(data) {
        this.data = data;
    }
}